module.exports = __webpack_public_path__ + "static/media/1_A1_10.668e4ce7.png";